import { Form } from 'react-bootstrap';

/**
 * Поле формы с лейблом
 */
export const FormField = ({ 
  label, 
  required = false, 
  children, 
  hint,
  className = 'mb-4' 
}) => {
  return (
    <Form.Group className={className}>
      {label && (
        <Form.Label className="fw-medium">
          {label} {required && <span className="text-danger">*</span>}
        </Form.Label>
      )}
      {children}
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
    </Form.Group>
  );
};
